// SMS-utsendelse helpers shared by the Besøkende page, the send drawer and
// the sent-SMS overview. Mirrors backend/lib/sms-bulk.js.

export const ACTIVE_STATUSES = ['queued', 'running'];
export const CHANNELS = ['sms', 'email'];

export function normalizeChannel(value) {
    return value === 'email' ? 'email' : 'sms';
}

export function isEmailChannel(value) {
    return normalizeChannel(value) === 'email';
}

export function canSendBulkSms({ isAdmin = false, isCustomerAdmin = false } = {}) {
    return !!(isAdmin || isCustomerAdmin);
}

export function isActiveStatus(status) {
    return ACTIVE_STATUSES.includes(status);
}

const MERGE_FIELDS = { fornavn: 'firstname', etternavn: 'lastname' };

// Fixed fields first ({{fornavn}}, {{etternavn}}), then per-recipient
// mergeFields ({{tid}}, {{dyr}} from the calendar-day send). Mirrors the backend.
export function fillMergeFields(body, recipient = {}) {
    const extra = recipient.mergeFields && typeof recipient.mergeFields === 'object' ? recipient.mergeFields : {};
    return String(body || '').replace(/\{\{\s*([a-zA-ZæøåÆØÅ]+)\s*\}\}/g, (match, key) => {
        const lower = key.toLowerCase();
        const field = MERGE_FIELDS[lower];
        if (field) {
            return recipient[field] || '';
        }
        return extra[lower] === undefined || extra[lower] === null ? '' : String(extra[lower]);
    });
}

// GSM 03.38 basic + extension characters (incl. æøå). Anything else forces
// UCS-2. Extension characters really cost two units, so this is a "ca." count.
const GSM_RE = /^[A-Za-z0-9 \r\n@£$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ!"#¤%&'()*+,\-./:;<=>?¡ÄÖÑÜ§¿äöñüà^{}\\[~\]|€]*$/;

export function countSmsSegments(body) {
    const text = String(body || '');
    if (!text) {
        return { chars: 0, segments: 0, encoding: 'gsm' };
    }
    const gsm = GSM_RE.test(text);
    const single = gsm ? 160 : 70;
    const multi = gsm ? 153 : 67;
    const chars = text.length;
    const segments = chars <= single ? 1 : Math.ceil(chars / multi);
    return { chars, segments, encoding: gsm ? 'gsm' : 'unicode' };
}

// Kalender-SMS drawer: candidates come from POST /api/calendarevents/bulk-sms/preview
// as { eventId, visitorId, ok, ... }. Every sendable row starts ticked.
export function defaultSelection(candidates = []) {
    return (Array.isArray(candidates) ? candidates : []).filter(c => c && c.ok).map(c => c.eventId);
}

// Owners with two appointments the same day get one SMS. The backend dedupes
// by mobile; this client-side count by visitorId is the number shown while
// composing. The job's `total` is the authoritative number once created.
export function uniqueRecipientCount(candidates = [], selectedIds = []) {
    const wanted = new Set(Array.isArray(selectedIds) ? selectedIds : []);
    const owners = new Set();
    (Array.isArray(candidates) ? candidates : []).forEach(c => {
        if (c && c.ok && wanted.has(c.eventId)) {
            owners.add(c.visitorId);
        }
    });
    return owners.size;
}
